<template>
  <div>
    <b-row>
      <b-col md="4" sm="12">
        <b-input-group prepend="Год заявки" class="mt-1" size="sm">
          <b-form-input readonly plaintext v-model="selectedItem.planYear" size="sm"
                        class="borderedInput ml-1">
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="8" sm="12">
        <b-input-group prepend="Мероприятие" class="mt-1" size="sm">
          <b-form-input readonly plaintext v-model="selectedItem.nameEvent" size="sm" class="borderedInput ml-1">
          </b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" sm="12">
        <b-input-group prepend="Главный тренер" class="mt-1" size="sm">
          <b-form-input readonly plaintext type="text" placeholder="Главный тренер"
                        size="sm" v-model="selectedItem.mainTrainer" class="borderedInput ml-1"/>
        </b-input-group>
      </b-col>
      <b-col md="6" sm="12">
        <b-input-group prepend="Главный врач" class="mt-1" size="sm">
          <b-form-input readonly plaintext type="text" placeholder="Главный врач"
                        size="sm" v-model="selectedItem.mainDoctor" class="borderedInput ml-1"/>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table striped small class="mt-1"
             :items="selectedItem.details"
             head-variant="dark"
             responsive
             sticky-header="60vh"
             :stacked="getStacked()"
             :fields="detColumns"
             show-empty
             empty-text='нет записей'
    >
    </b-table>
    <b-row>
      <b-col sm="6" class="text-left">
        <b-button size="sm" class="mr-2" variant="outline-primary" @click="exportExcel">в Excel</b-button>
        <b-button size="sm" v-if="downloadFileLink !== ''" variant="success" @click="downloadFile()">
          <b-icon icon="download"/>
          Скачать файл
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import http from '@/http-common'
import global from '../utils/global'

export default {
  props: {
    ekpId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedItem: {
        planYear: null,
        nameEvent: ''
      },
      stacked: {
        flg: false,
        size: 'md'
      },
      details: [],
      detColumns: [
        {key: 'num', label: '№ пп'},
        {key: 'fio', label: 'ФИО'},
        {key: 'yearBirth', label: 'Год рождения'},
        {key: 'rank', label: 'Спортивные звания'},
        {key: 'category', label: 'Весовая категория (кг)'},
        {key: 'school', label: 'Спортивное ведомство'},
        {key: 'trainer', label: 'Тренер'},
        {key: 'edit_field', label: '', sortable: false}
      ],
      downloadFileLink: '',
      dfileName: '',
    }
  },
  mounted() {
    this.loadRequestSport()
    this.onResize();
    this.downloadFileLink = ''
  },
  methods: {
    loadRequestSport() {
      var vm = this;
      http.get('/requestSport/byEkp?ekp_id=' + this.ekpId)
      .then((response) => {
        vm.selectedItem = response.data;
        var nn = 1;
        vm.selectedItem.details.forEach(function (x) {
          x.num = nn;
          nn++;
        })
      })
    },
    getStacked() {
      if (this.stacked.flg) {
        return this.stacked.size;
      } else {
        return false;
      }
    },
    onResize() {
      // Small (sm) <=540px
      if (document.documentElement.clientWidth > global.isMobileWidth()) {
        this.stacked.flg = false
        this.stacked.size = 'sm'
        this.detColumns.forEach(function (x) {
          x.class = x.firstClass;
        })
      } else {
        this.stacked.flg = true
        this.stacked.size = 'sm'
        this.detColumns.forEach(function (x) {
          x.class = null;
        })
      }
    },
    exportExcel() {
      this.downloadFileLink = '';
      if (this.selectedItem.details && this.selectedItem.details.length > 0) {
        http.post('/requestSport/export', this.selectedItem)
        .then((response) => {
          if (response.data.ok || response.data.name != '') {
            var link = '/report/download?name=' + encodeURIComponent(response.data.name);
            this.downloadFileLink = link;
            this.dfileName = 'Заявка на участие.xls';
          } else {
            alert("Заявка не сформирована!");
          }
        })
        .catch((error) => console.log(error.message));
      } else {
        alert("Заявка пустая!");
      }
    },
    downloadFile() {
      var vm = this;
      this.modalLoadOpened = true;
      http.get(this.downloadFileLink,
          {
            responseType: 'arraybuffer',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/pdf'
            }
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', vm.dfileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).finally(() => vm.modalLoadOpened = false);
    }
  }
}
</script>

<style>
.borderedInput {
  /*border: solid;*/
  /*border: 1px;*/
  border: solid 1px gray;
  outline: solid 1px silver;
}

.borderedInput:focus {
  outline: solid 2px black;
}
</style>

